import { LockIcon } from '@chakra-ui/icons';
import { Box, List, ListIcon, ListItem } from '@chakra-ui/react';
import React from 'react';
import { FaUserAlt } from "react-icons/fa";
import { LiaStoreAltSolid } from "react-icons/lia";
import { LuClipboardList } from "react-icons/lu";
import { TbLogout } from "react-icons/tb";
import { useNavigate } from 'react-router-dom';

const AdminSidebar = () => {
  const navigate = useNavigate();

  const handleLogoutClick = () => {
    sessionStorage.removeItem('token');
    window.location.reload();
  }

  return (
    <Box
      width='250px'
      borderRadius='15px'
      boxShadow='0px 0px 30px 0px rgb(0 0 0 / 5%)'
      padding='18px 15px 25px 25px'
      marginTop='30px'
      color='#315B84'
      fontSize='14px'
      bgColor='#FFFFFF'
    >
      <List spacing={5}>
        <ListItem cursor='pointer' onClick={() => navigate('/admin-dashboard')}>
          <ListIcon as={FaUserAlt} />
          Profile
        </ListItem>
        <ListItem cursor='pointer' onClick={() => navigate('/admin-dashboard/submit-a-property')}>
          <ListIcon as={LiaStoreAltSolid} />
          Submit a Property
        </ListItem>
        <ListItem cursor='pointer' onClick={() => navigate('/admin-dashboard/listed-properties')}>
          <ListIcon as={LuClipboardList} />
          Listed Properties
        </ListItem>
        <ListItem onClick={() => navigate('/admin-dashboard/change-password')} cursor='pointer'>
          <ListIcon as={LockIcon} />
          Change Password
        </ListItem>
        <ListItem onClick={handleLogoutClick} cursor='pointer'>
          <ListIcon as={TbLogout} />
          Logout
        </ListItem>
      </List>
    </Box>
  )
}

export default AdminSidebar